<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('decision.time') }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('member.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="item">
          <span class="label">{{ $t('order.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valOrderSn"
            :placeholder="$t('order.inp.order_no')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.site_name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valSiteName"
            :placeholder="$t('device.site_name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valDeviceId"
            :placeholder="$t('order.inp.device_no')"></el-input>
        </div>
        <!-- <div class="item">
          <span class="label">{{ $t('order.failed_reason') }}</span>
          <el-select class="inp" size="small" v-model="formData.valFailReason" :placeholder="$t('order.failed_reason')"
            filterable clearable allow-create>
            <el-option v-for="item in render.failReason" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div> -->
        <div class="item">
          <span class="label">{{ $t('device.device_id') }}</span>
          <el-input class="inp" size="small" v-model="formData.valBatteryId"
            :placeholder="$t('device.device_id')"></el-input>
        </div>
        <!-- <div class="item">
          <span class="label">{{ $t('order.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valTel" :placeholder="$t('order.inp.name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.idName" :placeholder="$t('g.enter_name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('member.mobile') }}</span>
          <el-input class="inp" size="small" v-model="formData.valPhone" :placeholder="$t('member.mobile')"></el-input>
        </div> -->

      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <!-- <div class="header">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
          }}</span>
        <div class="header-icons">
          <el-icon @click="func.refresh()" class="header-icon">
            <Refresh />
          </el-icon>
        </div>
      </div> -->
      <el-table :data="formData.tableData" style="width: 100%" @row-click="func.showDetails">
        <el-table-column prop="Id" label="Id" width="120" v-if="!isOperator()">
        </el-table-column>
        <el-table-column prop="OrderSn" :label="$t('order.no')" width="200">
        </el-table-column>
        <el-table-column prop="AgentCode" :label="$t('g.agent_code')" width="80">
        </el-table-column>
        <el-table-column prop="UserInfo.Nickname" width="100" :label="$t('bill.nickname')">
        </el-table-column>
        <el-table-column prop="UserInfo.Mobile" width="120" :label="$t('member.mobile')">
        </el-table-column>
        <el-table-column prop="UserInfo.IdName" width="100" :label="$t('member.IdName')">
        </el-table-column>
        <el-table-column width="100" :label="$t('member.status')">
          <template #default="scope">
            <el-tag
              :class="scope.row.DeviceStatus == 1 ? 'tag-success' : (scope.row.DeviceStatus == 2 ? 'tag-warning' : 'tag-fail')">
              {{ scope.row.StatusStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="DeviceId" min-width="260" :label="$t('device.no')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="DeviceSiteName" min-width="120" :label="$t('device.site_name')" show-overflow-tooltip>
        </el-table-column>

        <el-table-column width="150" :label="$t('order.failed_reason')" prop="FailReason" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="ExchangeBatteryOrderInfo.TakeBatterySn" width="240" :label="$t('order.took_battery.no')"
          show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="ExchangeBatteryOrderInfo.TakeBatterySoc" width="150"
          :label="$t('order.took_battery.soc')">
        </el-table-column>
        <el-table-column prop="ExchangeBatteryOrderInfo.TakeBoxNum" width="80" :label="$t('order.slot_get')">
        </el-table-column>
        <el-table-column prop="ExchangeBatteryOrderInfo.SaveBatterySn" width="240"
          :label="$t('order.returned_battery_no')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="ExchangeBatteryOrderInfo.SaveBoxNum" width="80" :label="$t('order.slot_return')">
        </el-table-column>
        <el-table-column prop="ExchangeStartStr" width="180" :label="$t('activityManage.start_time')">
        </el-table-column>
        <el-table-column prop="ExchangeEndStr" width="180" :label="$t('activityManage.end_time')">
        </el-table-column>
        <el-table-column width="120" :label="$t('device.life_time')">
          <template #default="scope">
            {{ scope.row.ExchangeBatteryOrderInfo?.ExTimeLen || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="Remark" width="80" :label="$t('order.remark')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="NamePath" min-width="180" :label="$t('g.operator_ownership')"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="CreatedAtStr" width="200" :label="$t('g.create_at')">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize }}
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <!-- <div class="pagination">
      <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
        :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
      </el-pagination>
    </div> -->
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" style="width: 90%;" align-center>
      <el-descriptions border column="4">
        <el-descriptions-item :label="$t('order.no')">{{ formData.curData.OrderSn }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item> <el-descriptions-item :label="$t('member.mobile')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Mobile
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('bill.nickname')">
          <el-link type="primary" @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Nickname
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('member.IdName')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.IdName
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('order.CabinetNumber')">
          <el-link type="primary" @click="formData.devDrawerVisible = true">{{ formData.curData.DeviceId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.site_name')">{{ formData.curData.DeviceSiteName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.status')">
          <el-tag
            :class="formData.curData.DeviceStatus == 1 ? 'tag-success' : (formData.curData.DeviceStatus == 2 ? 'tag-warning' : 'tag-fail')">
            {{ formData.curData.StatusStr }}
          </el-tag>
        </el-descriptions-item> <el-descriptions-item :label="$t('order.took_battery.no')">
          <el-link type="primary" @click="func.gotoDetail(formData.curData.ExchangeBatteryOrderInfo?.TakeBatterySn)">{{
            formData.curData.ExchangeBatteryOrderInfo?.TakeBatterySn
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('order.took_battery.soc')">{{
          formData.curData.ExchangeBatteryOrderInfo?.TakeBatterySoc
        }}%</el-descriptions-item>
        <el-descriptions-item :label="$t('order.TakeOutBatteryVoltage')">{{
          formData.curData.ExchangeBatteryOrderInfo?.TakeBatteryVolt ?
            formData.curData.ExchangeBatteryOrderInfo?.TakeBatteryVolt / 10 : ''
        }}V</el-descriptions-item>
        <el-descriptions-item :label="$t('order.ReturnBatterySoc')">{{
          formData.curData.ExchangeBatteryOrderInfo?.SaveBatterySoc
        }}%</el-descriptions-item>
        <el-descriptions-item :label="$t('order.ReturnBatteryVoltage')">{{
          formData.curData.ExchangeBatteryOrderInfo?.SaveBatteryVolt ?
            formData.curData.ExchangeBatteryOrderInfo?.SaveBatteryVolt / 10 : ''
        }}V</el-descriptions-item>
        <el-descriptions-item :label="$t('order.slot_get')">{{
          formData.curData.ExchangeBatteryOrderInfo?.TakeBoxNum }}</el-descriptions-item> <el-descriptions-item
          :label="$t('order.returned_battery_no')">
          <el-link type="primary" @click="func.gotoDetail(formData.curData.ExchangeBatteryOrderInfo?.SaveBatterySn)">{{
            formData.curData.ExchangeBatteryOrderInfo?.SaveBatterySn
          }}</el-link>
        </el-descriptions-item>

        <el-descriptions-item :label="$t('member.battery_status')">

          <el-link type="primary" @click="func.gotoDetail(formData.curData.ExchangeBatteryOrderInfo?.UserBatIds)">{{
            formData.curData.ExchangeBatteryOrderInfo?.UserBatIds
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('order.slot_return')">{{
          formData.curData.ExchangeBatteryOrderInfo?.SaveBoxNum }}</el-descriptions-item>

        <el-descriptions-item :label="$t('order.failed_reason')">{{ formData.curData.FailReason
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.remark')">{{ formData.curData.Remark }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreatedAtStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator_ownership')" span="4">{{ formData.curData.NamePath
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.slot_battery_before')" span="4">
          <div v-for="item in formData.curData.ExchangeBatteryOrderInfo?.BatIds" style="padding: 2px 0;">
            {{ item }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('order.event')" span="4">
          <div v-for="item in formData.curData.eboxEvent">
            {{ item.SlotId }}仓:{{ item.Type }} {{ item.CreatedAtStr }}
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-drawer v-model="formData.devDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <EboxList :propId="formData.curData.DeviceId"></EboxList>
    </el-drawer>
    <el-drawer v-model="formData.batDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <BatteryList :propId="formData.propBatId"></BatteryList>
    </el-drawer>
    <el-drawer v-model="formData.userDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <MemberList :propId="formData.curData.UserInfo.Id"></MemberList>
    </el-drawer>
  </div>
</template>

<script>
import { dayjs } from 'element-plus'
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { operators, updateOperators, shortcuts, cascade_options_direct } from '@/data/default'
import { toDay } from "@/common/func"
import i18n from '@/data/i18n/index'
import { isOperator } from '@/data/token'
import EboxList from '@/views/ebox/list.vue'
import BatteryList from '@/views/battery/list.vue'
import MemberList from '@/views/member/list.vue'
export default {
  name: 'OrderCabinet',
  components: {
    EboxList,
    BatteryList,
    MemberList
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('member.statuses.all'),
        value: -1
      },
      {
        label: t('member.statuses.success'),
        value: 1
      },
      {
        label: t('member.statuses.failed'),
        value: 0
      },
      {
        label: t('chart.order_statuses.doing'),
        value: 2
      }
    ]
    const failReason = [
      {
        label: t('order.failed_reasons.t1'),
        value: '无可换电池'
      },
      {
        label: t('order.failed_reasons.t2'),
        value: '关闭空仓门超时'
      },
      {
        label: t('order.failed_reasons.t3'),
        value: '不够空仓'
      },
      {
        label: t('order.failed_reasons.t4'),
        value: '插入电池超时'
      },
      {
        label: t('order.failed_reasons.t5'),
        value: '柜机忙'
      },
      {
        label: t('order.failed_reasons.t6'),
        value: '设备不在线'
      },
      {
        label: t('order.failed_reasons.t7'),
        value: '插入电池确认失败'
      },
      {
        label: t('order.failed_reasons.t8'),
        value: '柜机超时'
      },
    ]
    const render = {
      shortcuts,
      statuses,
      failReason,
      operators,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      CodePathID: 0,
      valStatus: -1,
      valTime: '',
      valTel: '',
      idName: '',
      valOrderSn: '',
      valDeviceId: '',
      valFailReason: '',
      dialogDisplayVisible: false,
      devDrawerVisible: false,
      batDrawerVisible: false,
      userDrawerVisible: false,
      propBatId: '',
      // pagination
      curPage: 1,
      pageSize: 10,
      total: 1,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1
    })
    const func = {
      gotoDetail(id) {
        formData.propBatId = id
        formData.batDrawerVisible = true
      },
      showDetails(row) {
        formData.dialogDisplayVisible = true;
        formData.curData = row;
        formData.curData.eboxEvent = []
        //func.getEboxEvent(formData.curData.OrderSn)
      },

      search() {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      refresh() {
        formData.CodePathID = 0
        formData.valStatus = -1
        formData.valTime = ''
        formData.valTel = ''
        formData.idName = ''
        func.loadData(1)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.valOrderSn) {
            params.orderSn = formData.valOrderSn
          }
          if (formData.valDeviceId) {
            params.deviceId = formData.valDeviceId.trim()
          }
          if (formData.valSiteName) {
            params.siteName = formData.valSiteName
          }
          if (formData.valFailReason) {
            params.fail_reason = formData.valFailReason
          }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          if (formData.valTel) {
            params.nickname = formData.valTel
          }
          if (formData.idName) {
            params.idName = formData.idName
          }
          if (formData.valPhone) {
            params.phoneNum = formData.valPhone
          }
          if (formData.valBatteryId) {
            params.BatId = formData.valBatteryId.trim()
          }
          if (formData.valStatus != -1) {
            params.status = formData.valStatus
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          params.IsStartWith = formData.IsStartWith
          let res = await axios.get(`/admin/order/bikebatexc`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreatedAt)
            item.ExchangeStartStr = (item.ExchangeBatteryOrderInfo && item.ExchangeBatteryOrderInfo.StartTime) ? toDay(item.ExchangeBatteryOrderInfo.StartTime) : ''
            item.ExchangeEndStr = (item.ExchangeBatteryOrderInfo && item.ExchangeBatteryOrderInfo.EndTime) ? toDay(item.ExchangeBatteryOrderInfo.EndTime) : ''
            switch (item.DeviceStatus) {
              case 0:
                item.StatusStr = t('member.statuses.failed')
                break
              case 1:
                item.StatusStr = t('member.statuses.success')
                break
              case 2:
                item.StatusStr = '进行中'
                break
            }
            // item.StatusStr = item.DeviceStatus === 1 ? t('member.statuses.success') : t('member.statuses.failed')
            item.ImagePre = []
            if (!item.DevImageList) {
              item.DevImageList = []
            }
            item.DevImageList.map((item2) => {
              item2.TypeName = ""
              switch (item2.OperType) {
                case 0:
                  item2.TypeName = t('order.imgs.t0')
                  break
                case 1:
                  item2.TypeName = t('order.imgs.t1')
                  break
                case 2:
                  item2.TypeName = t('order.imgs.t2')
                  break
                case 3:
                  item2.TypeName = t('order.imgs.t3')
                  break
              }
              item.ImagePre.push(item2.Image)
            })
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      //updateOperators()
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem 1.25rem 0 1.25rem;

  .inp-block {
    display: block;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;
      margin-top: 12px;

      >.search1 {
        background-color: #14b2ec;
        color: #fff;
        border: 1px solid #14b2ec;
      }

      >.search2 {
        background-color: #048cbe;
        color: #fff;
        border: 1px solid #048cbe;
      }

      >.search3 {
        background-color: #ee8094;
        color: #fff;
        border: 1px solid #ee8094;
      }

      >.search4 {
        background-color: #bdb2b5;
        color: #fff;
        border: 1px solid #bdb2b5;
      }

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;
        // justify-content: left;

        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }


  .pagination {
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;

    .title {
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  .dlg-bottom {
    display: flex;
    justify-content: space-around;
  }
}

.line {
  height: 1px;
  width: 100%;
  background-color: #e2e2e2;
  margin-top: 15px;
  margin-bottom: 15px;
}

@media screen and (max-width:1300px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(3, 32.2%);
      }
    }
  }
}

@media screen and (max-width:1030px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(2, 48.8%);
      }
    }
  }
}

@media screen and (max-width:792px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(1, 100%);
      }
    }
  }
}
</style>
